import React from 'react'
import PropTypes, { string } from 'prop-types'
import Topic from 'components/Shared/Topic'

const Topics = ({ keywords, keyPrefix, limit = 4 }) => {
  return (
    <ul className="mt-2">
      {keywords.slice(0, limit).map((keyword, index) => {
        // catches bad keywords
        const trimmedKeyword = keyword.trim()
        if (trimmedKeyword === '' || !trimmedKeyword) return null
  
        return <Topic key={`${keyPrefix}-${keyword}-${index}`} keyword={keyword} index={index} charLimit={30} />
      })}
    </ul>
  )
}
  
Topics.propTypes = {
  keywords: PropTypes.arrayOf(string),
  keyPrefix: PropTypes.string,
  limit: PropTypes.number,
}

export default Topics